<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12">
        <p class="primary--text mb-2 font-weight-bold">
          Filtrar
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="8" class="pr-sm-5 pr-0">
        <BaseFormAutocomplete
          id-element="filterQuotation"
          placeholder="Digite o Nome do Tomador ou CNPJ"
          v-model="quotationFilter.filter"
          :items="currentTakerQuotation"
          hide-no-data
          item-text="nome_fantasia"
          item-value="id"
          template-taker
          validate-on-blur
          @keyup="searchInput"
          :return-object="true"
          :rules="[requiredValidTaker]"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <p class="primary--text font-weight-bold body-2 mb-0">
          Status
        </p>
        <v-checkbox
          v-model="quotationFilter.em_andamento"
          label="Em Andamento"
          class="d-inline-block pr-5 ma-0 quotation-table__checkbox pt-0"
          dense
        />
        <v-checkbox
          v-model="quotationFilter.finalizado"
          label="Finalizado"
          dense
          class="d-inline-block ma-0 quotation-table__checkbox pt-0"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4" class="pr-md-5 pr-0">
        <BaseSelect
          placeholder="Tipos de Filtros"
          :items="listTypesFilter"
          v-model="quotationFilter.tipo"
          item-text="nome"
          item-value="id"
          :return-object="true"
        />
      </v-col>
      <v-col
        cols="12"
        sm="3"
        md="2"
        class="pr-md-5 pr-0"
        v-if="indexIntervalDateFilter > -1"
      >
        <BaseFilter
          v-model="quotationFilter.inicio"
          :textPlaceholder="'DD/MM/AAAA'"
          outlined
          dense
          v-facade="maskDate"
          :rules="[dateTermValid, requiredInput]"
          validate-on-blur
          required
        />
      </v-col>
      <v-col
        cols="12"
        sm="3"
        md="2"
        class="pr-md-5 pr-0"
        v-if="indexIntervalDateFilter > -1"
      >
        <BaseFilter
          v-model="quotationFilter.fim"
          :textPlaceholder="'DD/MM/AAAA'"
          outlined
          dense
          v-facade="maskDate"
          :rules="[dateTermValid, requiredInput]"
          validate-on-blur
          required
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        class="pr-md-5 pr-0"
        v-if="indexIntervalDateFilter == -1"
      >
        <BaseSelect
          placeholder="Selecione"
          :items="currentSelectFilterQuotation"
          v-model="quotationFilter.valor"
          v-if="indexSelectFilter > -1"
          :multiple="true"
          item-text="nome"
          item-value="id"
          required
          :rules="[requiredInput]"
        />
        <BaseFilter
          v-model="quotationFilter.valor"
          :textPlaceholder="'Informe'"
          outlined
          dense
          v-if="indexNormalFilter > -1"
          required
          :rules="[requiredInput]"
        />
        <BaseFormAutocomplete
          id-element="autocompleteQuotation"
          placeholder="Autocomplete"
          v-model="quotationFilter.valor"
          :items="currentAutoCompleteFilterQuotation"
          hide-no-data
          item-text="nome"
          item-value="id"
          validate-on-blur
          @keyup="searchInput"
          v-if="indexAutocompleteFilter > -1 && indexAutocompleteFilter != 3"
          :return-object="true"
          required
          :rules="[requiredInput]"
        />
        <BaseFormAutocomplete
          id-element="autocompleteQuotation"
          placeholder="Autocomplete"
          v-model="quotationFilter.valor"
          :items="currentAutoCompleteFilterQuotation"
          hide-no-data
          item-text="numero"
          item-value="id"
          validate-on-blur
          @keyup="searchInput"
          v-if="indexAutocompleteFilter == 3"
          :return-object="true"
          required
          :rules="[requiredInput]"
        />
      </v-col>
      <v-spacer />
      <v-col cols="12" sm="6" md="2" class="pr-0 pb-5 pb-md-0 pr-sm-3">
        <BaseButton
          v-html="'PESQUISAR'"
          class="secondary white--text"
          width="100%"
          @click="searchByFilter"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2" class="pb-5 pb-md-0">
        <BaseButton
          v-html="'LIMPAR'"
          color="secondary"
          width="100%"
          outlined
          @click="resetFilter"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="header"
          :items="listQuotation"
          no-data-text="Nenhuma Cotação foi encontrada"
          loading-text="Carregando Cotações..."
          :options.sync="options"
          :server-items-length="totalQuotation"
          class="quotation-table base__datatable"
          @click:row="redirectToQuotation"
          :footer-props="{'items-per-page-options':[25, 50, 100, 250, 500]}"
        >
          <template v-slot:[`item.numero`]="{ item }">
              <div class="quotation-table__padding">
                {{ item.numero }}
              </div>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div :class="statusColor(item.status)">
              {{ item.status.nome }}
            </div>
          </template>
          <template v-slot:[`item.dias_status`]="{ item }">
            {{ item.dias_status || "-" }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
const tableHeaders = [
  { text: "N° da Solicitação", value: "numero", sortable: true },
  {
    text: "Tomador Matriz/Filial",
    value: "tomador.nome_fantasia",
    sortable: true
  },
  { text: "Segurado Beneficiário", value: "segurado.nome", sortable: true },
  { text: "N° do Processo Judicial", value: "numero_processo", sortable: true },
  { text: "Sub-Modalidade", value: "submodalidade.nome", sortable: true },
  { text: "Status", value: "status", sortable: true },
  { text: "Dias no status", value: "dias_status", sortable: true }
];
const colorByStatus = [
  { color: "pink", status: "cancelada" },
  { color: "blue", status: "apolice_emitida" },
  { color: "light-blue", status: "aguardando_emissao_minuta" },
  { color: "light-blue", status: "aguardando_analise_minuta" },
  { color: "yellow", status: "em_andamento" }
];
const DEFAULT_STATUS = { color: "yellow" };
const MOCK_FILTER = {
  finalizado: false,
  em_andamento: false,
  valor: null,
  tipo: {
    nome: null,
    id: null
  },
  filter: null,
  inicio: null,
  fim: null
};
const MOCK_TYPES_FILTER = [
  {
    nome: "Número Interno Cliente",
    id: "numero_controle_interno"
  },
  {
    nome: "Número do Processo Judicial",
    id: "numero_processo"
  },
  {
    nome: "Início de Vigência",
    id: "data_inicio_vigencia"
  },
  {
    nome: "Término de Vigência",
    id: "data_fim_vigencia"
  },
  {
    nome: "Seguradora",
    id: "seguradoras"
  },
  {
    nome: "Tribunal",
    id: "tribunal_id"
  },
  {
    nome: "Grupo Econômico",
    id: "grupo_economico_id"
  },
  {
    nome: "Modalidade",
    id: "modalidades"
  },
  {
    nome: "SubModalidade",
    id: "submodalidades"
  },
  {
    nome: "Reclamante/Segurado",
    id: "segurado_id"
  },
  {
    nome: "Número Solicitação",
    id: "numero"
  },
  {
    nome: "Status",
    id: "status"
  }
];
const MOCK_AUTOCOMPLETE_FILTER = [
  "Tribunal",
  "Grupo Econômico",
  "Reclamante/Segurado",
  "Número Solicitação"
];
const MOCK_NORMAL_FILTER = [
  "Número Interno Cliente",
  "Número do Processo Judicial"
];
const MOCK_INTERVAL_DATE_FILTER = ["Início de Vigência", "Término de Vigência"];
const MOCK_SELECT_FILTER = [
  "Seguradora",
  "Modalidade",
  "SubModalidade",
  "Status"
];
import {
  formatExpirationDate,
  formatDDMMYYYYToIsoDate
} from "@/utils/formats.js";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { maskDate } from "@/utils/masks.js";
import _ from "lodash";
import { dateTermValid, requiredInput } from "@/utils/rules.js";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import { defaultFilterOptions } from "@/mixins/PayloadDataTableMixin";
export default {
  data() {
    return {
      quotationFilter: null,
      currentFilter: null,
      listTypesFilter: MOCK_TYPES_FILTER,
      header: tableHeaders,
      listColorByStatus: colorByStatus,
      formatExpirationDate,
      options: defaultFilterOptions(),
      maskDate,
      timeout: null,
      dateTermValid,
      formatDDMMYYYYToIsoDate,
      initializeFilter: false,
      currentTab: 1,
      requiredInput
    };
  },
  watch: {
    options: {
      handler(value) {
        this.fetchQuotation(this.getPayload(value));
      },
      deep: true
    },
    "quotationFilter.tipo"() {
      // Toda vez que trocar o filtro, tem que resertar o valor antigo
      if (this.initializeFilter) return;
      this.quotationFilter.valor = null;
      this.quotationFilter.inicio = null;
      this.quotationFilter.fim = null;
      this.resetCurrentFilters();
      if (this.indexSelectFilter > -1)
        this.fetchSelectFilter(this.indexSelectFilter);
    }
  },
  mixins: [LoadingRequest, CommonPayload],
  created() {
    this.initialize();
  },
  computed: {
    ...mapState("quotation", [
      "listQuotation",
      "totalQuotation",
      "currentAutoCompleteFilterQuotation",
      "currentTakerQuotation",
      "currentSelectFilterQuotation"
    ]),
    ...mapState(["nameOptionsDataTable", "filterDataTable"]),
    indexAutocompleteFilter() {
      return MOCK_AUTOCOMPLETE_FILTER.indexOf(this.quotationFilter.tipo.nome);
    },
    indexSelectFilter() {
      return MOCK_SELECT_FILTER.indexOf(this.quotationFilter.tipo.nome);
    },
    indexNormalFilter() {
      return MOCK_NORMAL_FILTER.indexOf(this.quotationFilter.tipo.nome);
    },
    indexIntervalDateFilter() {
      return MOCK_INTERVAL_DATE_FILTER.indexOf(this.quotationFilter.tipo.nome);
    },
    requiredValidTaker() {
      return (
        this.validateFilterTaker() || "É preciso selecionar um tomador válido"
      );
    }
  },
  methods: {
    ...mapActions("quotation", [
      "requestListQuotation",
      "requestCourtQuotation",
      "requestEconomicGroupQuotation",
      "requestInsuredQuotation",
      "requestNumberQuotation",
      "requestTakerQuotation",
      "requestSelectFilterQuotation",
      "requestInsuranceCompanyQuotation",
      "requestModalityQuotation",
      "requestSubModalityQuotation",
      "resetCurrentFilters",
      "requestStatusQuotation"
    ]),
    initialize() {
      this.updateOptionsAccordingTabView(this.currentTab);
      this.initializeFilter = true;
      this.quotationFilter =
        this.nameOptionsDataTable == this.$route.name &&
        _.isObject(this.filterDataTable)
          ? this.filterDataTable
          : _.cloneDeep(MOCK_FILTER);
      this.searchByFilter();
      this.initializeFilter = false;
    },
    searchInput(value) {
      clearTimeout(this.timeout);
      let vm = this;
      // fazer requisição apenas se tiver valor no input
      if (value.target.value.length >= 3)
        this.timeout = setTimeout(function() {
          const index =
            value.target.id == "filterQuotation"
              ? -1
              : vm.indexAutocompleteFilter;
          vm.fetchAutocompleteFilter(value.target.value, index);
          vm.timeout = null;
        }, 500);
    },
    fetchAutocompleteFilter(value, index) {
      const payload = `?query=${value}`;
      if (index == -1) {
        this.withLoading(this.requestTakerQuotation(payload));
      } else if (MOCK_AUTOCOMPLETE_FILTER[index] == "Tribunal") {
        this.withLoading(this.requestCourtQuotation(payload));
      } else if (MOCK_AUTOCOMPLETE_FILTER[index] == "Grupo Econômico") {
        this.withLoading(this.requestEconomicGroupQuotation(payload));
      } else if (MOCK_AUTOCOMPLETE_FILTER[index] == "Reclamante/Segurado") {
        this.withLoading(this.requestInsuredQuotation(payload));
      } else if (MOCK_AUTOCOMPLETE_FILTER[index] == "Número Solicitação") {
        this.withLoading(this.requestNumberQuotation(payload));
      }
    },
    fetchSelectFilter(index) {
      if (MOCK_SELECT_FILTER[index] == "Seguradora") {
        this.withLoading(this.requestInsuranceCompanyQuotation());
      } else if (MOCK_SELECT_FILTER[index] == "Modalidade") {
        this.withLoading(this.requestModalityQuotation());
      } else if (MOCK_SELECT_FILTER[index] == "SubModalidade") {
        this.withLoading(this.requestSubModalityQuotation());
      } else if (MOCK_SELECT_FILTER[index] == "Status") {
        this.withLoading(this.requestStatusQuotation());
      }
    },
    fetchQuotation(payload) {
      this.withLoading(this.requestListQuotation(payload));
    },
    validateFilterTaker() {
      return (
        !this.quotationFilter.filter || Boolean(this.quotationFilter.filter?.id)
      );
    },
    validate() {
      const validateForm = this.quotationFilter.tipo.id
        ? this.$refs.form.validate()
        : true;
      return validateForm && this.validateFilterTaker();
    },
    searchByFilter() {
      if (!this.validate()) return;
      this.currentFilter = _.cloneDeep(this.quotationFilter);
      this.fetchQuotation(this.getPayload(this.options));
    },
    resetFilter() {
      this.options = _.cloneDeep(defaultFilterOptions());
      this.quotationFilter = _.cloneDeep(MOCK_FILTER);
      this.currentFilter = _.cloneDeep(MOCK_FILTER);
      this.fetchQuotation(this.getPayload(this.options));
    },
    borderColor(item) {
      const status =
        this.listColorByStatus.find(x => x.status == item.id) || DEFAULT_STATUS;        
      return `quotation-table__border-${status.color}`;
    },
    statusColor(item) {
      return `quotation-table__status-${item.id}`;
    },
    getFilterPayload() {
      // O usuário só pode escolher apenas um tipo de filtro
      // Conforme for a escolha do filtro, vai alterar o payload
      const filterChosen =
        this.currentFilter.tipo.id == null
          ? ""
          : this.currentFilter.tipo.id == "numero"
          ? `&${this.currentFilter.tipo.id}=${this.currentFilter.valor.numero}`
          : ["data_inicio_vigencia", "data_fim_vigencia"].includes(
              this.currentFilter.tipo.id
            )
          ? this.payloadDateFilterQuotation()
          : ["tribunal_id", "grupo_economico_id", "segurado_id"].includes(
              this.currentFilter.tipo.id
            )
          ? `&${this.currentFilter.tipo.id}=${this.currentFilter.valor.id ||
              "00000000-0000-0000-0000-000000000000"}`
          : `&${this.currentFilter.tipo.id}=${this.currentFilter.valor}`;
      return `${this.payloadTakerFilterQuotation()}&em_andamento=${
        this.currentFilter.em_andamento
      }&finalizado=${this.currentFilter.finalizado}${filterChosen}`;
    },
    payloadTakerFilterQuotation() {
      return this.currentFilter.filter
        ? this.currentFilter.filter.id
          ? `&tomador_id=${this.currentFilter.filter.id}`
          : `&query=${this.currentFilter.filter}`
        : "";
    },
    payloadDateFilterQuotation() {
      const inicio = `&${
        this.currentFilter.tipo.id
      }_de=${this.formatDDMMYYYYToIsoDate(this.currentFilter.inicio)}`;
      const fim = `&${
        this.currentFilter.tipo.id
      }_ate=${this.formatDDMMYYYYToIsoDate(this.currentFilter.fim)}`;
      return `${inicio}${fim}`;
    },
    getPayload(options) {
      const { page, itemsPerPage, sortDesc, sortBy } = options;
      const directSort =
        sortBy.length == 1 ? (sortDesc[0] ? "desc" : "asc") : "desc";
      // Pegar do headers o elemento que será ordenado
      const sort = sortBy.length == 1 ? sortBy[0] : "";
      return `?page=${page}&page_size=${itemsPerPage}&sort=${sort}&direction=${directSort}${this.getFilterPayload()}`;
    },
    redirectToQuotation(item) {
      this.saveOptionsDataTable(this.payloadOptions(this.currentTab));
      this.$router.push({ name: "quotation element", params: { id: item.id } });
    }
  }
};
</script>
<style lang="sass">
.quotation-table__
  &checkbox
    label
      font-size: 14px
      font-weight: 400
      color: #676778 !important
  &border-blue
    border-left: 5px solid #059EE4
  &border-light-blue
    border-left: 5px solid #49DCBB
  &border-yellow
    border-left: 5px solid #FFC55F
  &border-pink
    border-left: 5px solid #EF5350
  &status-cancelada
    background-color: rgba(129,131,134,0.1)
    color: rgba(129,131,134,1)
    text-align: center
  &status-apolice_emitida     
    background-color: rgba(58, 99, 222, 0.1)
    color: rgba(58, 99, 222, 1)
    text-align: center
    letter-spacing: 0px
  &status-aguardando_emissao_minuta
    background-color: rgba(37, 156, 140, 0.1)
    color: rgba(37, 156, 140, 1)
    text-align: center
  &status-aguardando_analise_minuta
    background-color: rgba(129,131,134,0.1)
    color: rgba(129,131,134,1)
    text-align: center
  &status-aguardando_aprovacao_minuta
    background-color: rgba(255,197,95,0.1)
    color: rgba(255,197,95,1)
    text-align: center
  &status-em_andamento
    background-color: rgba(129,131,134,0.1)
    color: rgba(129,131,134,1)
    text-align: center
  &status-aguardando_emissao_apolice
    background-color: rgba(255,197,95,0.1)
    color: rgba(255,197,95,1)
    text-align: center
  &padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
.quotation-table
  tbody tr
    cursor: pointer    
.quotation-table.v-data-table.theme--light
  tbody tr td:first-child
    padding: 2px 0px !important
</style>
